import { useEffect } from 'react';
import { batch } from 'react-redux';
import { openDlg } from 'src/store/Dialog';
import { setClickedTab, setTab, setTabsData } from 'src/store/Tabs';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { DialogClick, DialogType } from 'src/types/Dialog';
import { Translation } from 'src/types/Translation';
import { useTranslations } from './useTranslations';

export const useTab = () => {
  const dispatch = useAppDispatch();
  const unSavedWarning = useTranslations({} as Translation, {}, 'unSavedWarning');
  const close = useTranslations({} as Translation, {}, 'close');
  const ok = useTranslations({} as Translation, {}, 'ok');
  const confirmExit = useTranslations({} as Translation, {}, 'confirmExit');
  const { tab: tabVal, clickedTab, tabsData } = useAppSelector(state => state.tabs);
  const dlgType = useAppSelector(state => state.dialog.type);
  const dlgClick = useAppSelector(state => state.dialog.dlgClick);
  const confirmexitvalue: any = useAppSelector(state => state.confirmexitvalue.confirmexitvalue);
  const confirmexitpopupval: any = useAppSelector(state => state.confirmexitpopupval.confirmexitpopupval);
  const setTabVal = (selTab: number) => {
    //if ((confirmexitvalue !== true || confirmexitpopupval !== true) && dlgType !== DialogType.Data) {
    if (confirmexitvalue !== true || confirmexitpopupval !== true) {
      updateStore(selTab);
    } else {
      batch(() => {
        dispatch(setClickedTab(selTab));
        setConfirmExitPopupVal(dispatch, true);
        if (dlgType === DialogType.Data) {
          dispatch(
            openDlg({
              title: confirmExit.confirmExit,
              text: unSavedWarning.unSavedWarning,
              okText: ok.ok,
              cancelText: close.close
            })
          );
        }
      });
    }
  };

  useEffect(() => {
    if (dlgClick !== undefined && dlgClick === DialogClick.Ok && dlgType === DialogType.Data) {
      move();
    }
  }, [dlgClick]);

  const updateStore = (selTab: number) => {
    batch(() => {
      dispatch(setTab(selTab));
      setConfirmExitValue(dispatch, false);
      setConfirmExitPopupVal(dispatch, false);
    });
  };
  const move = () => {
    updateStore(clickedTab);
  };

  return { setTabVal, tabVal, setClickedTab, clickedTab, move, tabsData, setTabsData };
};
